import { sa } from '../../superAdminUi';

// Shared look for the Edit user panel, on the Super Admin tokens. The change tints match the
// account-status pills (green = added/active, red = removed/failed).
export const tone = {
  added: { bg: '#e1f5ee', fg: '#0f6e56' },
  removed: { bg: '#fcebeb', fg: '#a32d2d' },
  info: { bg: '#eef6fb', fg: '#245a7a' },
};

export const sectionTitleSx = {
  fontFamily: sa.font.family,
  fontSize: 13,
  fontWeight: sa.font.semibold,
  color: sa.color.text,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  mb: 1.25,
};

export const labelSx = {
  fontFamily: sa.font.family,
  fontSize: 13,
  fontWeight: sa.font.medium,
  color: sa.color.text,
  mb: 0.5,
  display: 'block',
};

export const hintSx = {
  fontFamily: sa.font.family,
  fontSize: 12.5,
  color: sa.color.textGray,
  lineHeight: 1.5,
};

export const fieldSx = {
  fontFamily: sa.font.family,
  '& .MuiOutlinedInput-root': { borderRadius: sa.radius.sm, fontFamily: sa.font.family, fontSize: 14 },
  '& .MuiOutlinedInput-notchedOutline': { borderColor: sa.color.stroke },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: sa.color.teal },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: sa.color.teal },
};

export const rowSx = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 1.25,
  px: 1.5,
  py: 1.1,
  border: `1px solid ${sa.color.stroke}`,
  borderRadius: sa.radius.md,
  background: sa.color.white,
};

export const badgeSx = (t) => ({
  display: 'inline-block',
  fontFamily: sa.font.family,
  fontSize: 11,
  fontWeight: sa.font.semibold,
  lineHeight: '18px',
  px: 1,
  borderRadius: sa.radius.pill,
  background: t.bg,
  color: t.fg,
  whiteSpace: 'nowrap',
});

export const noteSx = (t = tone.info) => ({
  fontFamily: sa.font.family,
  fontSize: 13,
  lineHeight: 1.5,
  color: t.fg,
  background: t.bg,
  borderRadius: sa.radius.md,
  px: 1.5,
  py: 1.1,
});
